import React, { FC, PropsWithChildren } from 'react';
import styles from './Browser.scss';
import { BrowserHeader } from './BrowserHeader';

type Props = PropsWithChildren<{
  headerUrl?: string;
}>;

export const Browser: FC<Props> = ({ headerUrl, children }) => {
  return (
    <div className={styles.browser}>
      <BrowserHeader url={headerUrl} />
      <div className={styles.browserContent}>{children}</div>
    </div>
  );
};
